import { useState } from 'react';
import '../styles/header.css'
import logo from '../../assets/icons/logo.svg'
import logo2 from '../../assets/icons/logo2.svg'
import Nav from '../Nav';
import NavButtons from '../NavButtons';
import Burger from '../core/Burger'
import MobileNav from '../MobileNav';
import { Link } from 'react-router-dom';

const Header = ({type = ''}) => {
    const [mobileNav,setMobileNav] = useState(false)

    const mobileNavHandler = (event) => {
        if(event.target.id === 'modal-toggle'){
            document.body.classList.toggle('block-scroll')
            setMobileNav((state) => !state)
        }
    }

    if(type === 'faq'){
        return (
        <header className='header-faq'>
            <div className="container">
                <div className='header__logo faq-logo'>
                    <Link to={'/'}>
                        <img src={logo2} alt={'logo'}/>
                    </Link>
                </div>
                <div className='header__nav'>
                    <Nav type={type}/>
                    <MobileNav 
                    handler={mobileNavHandler}
                    isVisible={mobileNav}/>
                </div>
                <div className='header__buttons faq-buttons'>
                    <NavButtons type={type}/>
                </div>
                <Burger 
                type={type}
                handler={mobileNavHandler}
                active={mobileNav}/>
            </div>
        </header>
        )
    }


    return (
        <header className='header'>
            <div className="container">
                <Link className='header__logo' to={'/'}>
                    <img src={logo} alt={'logo'}/>
                </Link>
                <div className='header__nav'>
                    <Nav/>
                    <MobileNav 
                    handler={mobileNavHandler}
                    isVisible={mobileNav}/>
                </div>
                <div className='header__buttons'>
                    <NavButtons/>
                </div>
                <Burger
                type={type} 
                handler={mobileNavHandler}
                active={mobileNav}/>
            </div>
        </header>
    );
}

export default Header;
